import type { ComponentType } from 'react'
import { useSearchParams } from 'react-router'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { LogosTab } from '@/components/assets/logos-tab'

interface AssetTabDefinition {
  id: string
  label: string
  Panel: ComponentType
}

const ASSET_TABS: AssetTabDefinition[] = [
  { id: 'logos', label: 'Logos', Panel: LogosTab },
  // Add more entries here (e.g. icons, illustrations) with matching TabsContent below.
]

export function AssetsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const defaultTab = ASSET_TABS[0]?.id ?? 'logos'
  const activeTab = searchParams.get('tab') || defaultTab

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value })
  }

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          {ASSET_TABS.map(t => (
            <TabsTrigger key={t.id} value={t.id}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {ASSET_TABS.map(t => (
          <TabsContent key={t.id} value={t.id} className="mt-6">
            <t.Panel />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  )
}
